const fetchTimestamps = new Map<string, number>();

const EDITOR_CONTENT_TTL_MS = 15_000;

// Module state on the server is shared across Bifrost requests, so every function is a no-op there.
function isSSR(): boolean {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	return Boolean(process.env.REACT_SSR);
}

function getKey(contentId: string, draftShareId?: string | null): string {
	return `${contentId}:${draftShareId || ''}`;
}

// Entries of pages the editor never showed (a warm-up without a click) are never cleared otherwise.
function deleteExpired(): void {
	const now = performance.now();
	for (const [key, fetchedAt] of fetchTimestamps) {
		if (now - fetchedAt > EDITOR_CONTENT_TTL_MS) {
			fetchTimestamps.delete(key);
		}
	}
}

export function isEditorContentFresh(contentId: string, draftShareId?: string | null): boolean {
	if (isSSR()) {
		return false;
	}
	const fetchedAt = fetchTimestamps.get(getKey(contentId, draftShareId));
	return fetchedAt !== undefined && performance.now() - fetchedAt <= EDITOR_CONTENT_TTL_MS;
}

export function markEditorContentFetched(contentId: string, draftShareId?: string | null): void {
	if (isSSR()) {
		return;
	}
	deleteExpired();
	fetchTimestamps.set(getKey(contentId, draftShareId), performance.now());
}

// Clears every draftShareId variant of the content.
export function clearEditorContentFetched(contentId: string): void {
	if (isSSR()) {
		return;
	}
	deleteExpired();
	const prefix = `${contentId}:`;
	for (const key of fetchTimestamps.keys()) {
		if (key.startsWith(prefix)) {
			fetchTimestamps.delete(key);
		}
	}
}

export function clearAllEditorContentFetched(): void {
	fetchTimestamps.clear();
}
